/* eslint-disable max-len */
var UI_PLAY = {
  "default": 'M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm9.9,25.9A14,14,0,1,1,30,16,14,14,0,0,1,25.9,25.9ZM23.77,15h0L13,8.82a1.56,1.56,0,0,0-.8-.22,1.6,1.6,0,0,0-1.6,1.6V22.6a1.63,1.63,0,0,0,.49,1.16,1.58,1.58,0,0,0,1.11.44A1.65,1.65,0,0,0,13,24h0l10.74-6.2h0a1.6,1.6,0,0,0,0-2.77Zm-1,1ZM12,22.25h0l-.06,0Zm.6-.34v-11l9.54,5.5Z'
};

export { UI_PLAY };
//# sourceMappingURL=UI_PLAY.js.map
